<template>
  <v-container>
    <h2 style="color:gray">Cài Đặt Nâng cao</h2>
    <v-divider class="my-3"></v-divider>

    <v-row class="py-3">
      <v-col cols="12">
        <v-checkbox
          hide-details
          value="view-advance-group"
          :label="'Cho phép ' + roleName + ' thiết lập nâng cao'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <!-- năm học -->
      <!-- <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="view-school-year"
          :label="'Cho phép ' + roleName + ' xem cài đặt năm học'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col> -->
      <!-- <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          :label="'Cho phép ' + roleName + ' mở năm học'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          :label="'Cho phép ' + roleName + ' tổng kết học kỳ'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          :label="'Cho phép ' + roleName + ' đóng năm học'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col> -->

      <!-- bộ môn -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="view-subjectGroup-list"
          :label="'Cho phép ' + roleName + ' xem danh sách bộ môn'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="add-new-subjectGroup"
          :label="'Cho phép ' + roleName + ' thêm bộ môn'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="update-subjectGroup"
          :label="'Cho phép ' + roleName + ' sửa bộ môn'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="delete-subjectGroup"
          :label="'Cho phép ' + roleName + ' xóa bộ môn'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <!-- phân ban -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="view-division-list"
          :label="'Cho phép ' + roleName + ' xem danh sách phân ban'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="add-new-division"
          :label="'Cho phép ' + roleName + ' thêm phân ban'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="update-division"
          :label="'Cho phép ' + roleName + ' sửa phân ban'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="delete-division"
          :label="'Cho phép ' + roleName + ' xóa phân ban'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <!-- môn học -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="view-subject-list"
          :label="'Cho phép ' + roleName + ' xem danh sách môn học'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="add-new-subject"
          :label="'Cho phép ' + roleName + ' thêm môn học'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="update-subject"
          :label="'Cho phép ' + roleName + ' sửa môn học'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="delete-subject"
          :label="'Cho phép ' + roleName + ' xóa môn học'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <!-- cấp học -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          value="config-academic-level"
          :label="'Cho phép ' + roleName + ' cấu hình cấp học'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
    </v-row>

    <v-divider class="my-3"></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text class="mx-5" @click="reset()">Đặt lại</v-btn>
      <v-btn color="primary" @click="save()">Lưu</v-btn>
    </v-card-actions>
  </v-container>
</template>

<script>
import mixins from './helper/mixins'
export default {
  mixins: [mixins]
}
</script>
